import React from 'react';
import { connect } from 'react-redux';
import { catalogBibShape } from '@bibliocommons/bc-prop-types';
import { selectCatalogBib } from 'app/selectors/catalogBibs/CatalogBibSelector';
import FullDetails from './FullDetails';

export class FullDetailsContainer extends React.PureComponent {
  render() {
    return <FullDetails {...this.props} />;
  }
}

FullDetailsContainer.propTypes = {
  catalogBib: catalogBibShape
};

const mapStateToProps = state => ({
  catalogBib: selectCatalogBib(state)
});

export default connect(mapStateToProps)(FullDetailsContainer);
